import { useEffect, useReducer, useState } from 'react';
import {
	StyledContainer,
	StyledSlider,
	StyledSliderContainer,
} from './Slider.styled';

interface ISliderOldProps {
	min: number;
	max: number;
	step: number;
	value: number;
	disabled?: boolean;
	onChange: (newValue: number) => void;
}

const SliderOld: React.FC<ISliderOldProps> = ({
	min,
	max,
	step,
	value,
	disabled,
	onChange,
}: ISliderOldProps) => {
	const [sliderRef, setSliderRef] = useState<HTMLInputElement | null>(null);
	const [, forceUpdate] = useReducer((x) => (x + 1) % 10, 0);

	const onSlide = (e: React.ChangeEvent<HTMLInputElement>) => {
		const sliderValue = Number(e.target.value);
		onChange(sliderValue);
	};

	useEffect(() => {
		if (sliderRef?.value && Number(sliderRef.value) !== value) {
			sliderRef.value = String(value);
			forceUpdate();
		}
	}, [value, sliderRef]);

	return (
		<StyledContainer>
			<StyledSliderContainer>
				<StyledSlider
					onChange={onSlide}
					min={min}
					max={max}
					step={step}
					ref={(ref) => setSliderRef(ref)}
					style={{
						background: `linear-gradient(
							to right,
							#2D70DA 0%,
							#2D70DA calc(10px + (100% - 20px)*${
								(Number(sliderRef?.value ?? value) - min) / (max - min)
							}),
							transparent calc(10px + (100% - 20px)*${
								(Number(sliderRef?.value ?? value) - min) / (max - min)
							}),
							transparent 100%
						)`,
					}}
					disabled={disabled}
				/>
			</StyledSliderContainer>
		</StyledContainer>
	);
};

export { SliderOld };
